import http from './http'
import common from './common'

export default angular.module('service', [
    http,
    common,
]).name;